"use client";

import { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Capacity() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    }
  }, []);
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const statsEn = [{
    index: "01",
    figure: "24/7",
    label: "operational capacity",
    footnote: "Continuous production cycles across our specialized plastic and plush manufacturing facilities."
  }, {
    index: "02",
    figure: "100%",
    label: "compliance verified",
    footnote: "Full adherence to international safety standards including BV, ITS, SGS, and TUV Rheinland."
  }, {
    index: "03",
    figure: "50+",
    label: "global markets",
    footnote: "Serving diverse international regions with localized certification expertise like CCC and G-Mark."
  }, {
    index: "04",
    figure: "15+",
    label: "years of expertise",
    footnote: "Decades of dedicated OEM/ODM service providing end-to-end manufacturing solutions."
  }];
  const statsZh = [{
    index: "01",
    figure: "24/7",
    label: "全天候運營產能",
    footnote: "在我們專業的塑膠與毛絨製造基地實現不間斷的連續生產週期。"
  }, {
    index: "02",
    figure: "100%",
    label: "100% 合規驗證",
    footnote: "全面遵循 BV、ITS、SGS 及 TUV Rheinland 等國際頂級安全認證標準。"
  }, {
    index: "03",
    figure: "50+",
    label: "全球市場覆蓋",
    footnote: "憑藉 CCC 及 G-Mark 等在地化認證專業知識，服務全球多個國際市場與地區。"
  }, {
    index: "04",
    figure: "15+",
    label: "多年專業製造經驗",
    footnote: "深耕 OEM/ODM 製造領域多年，提供全方位的端到端一站式製造解決方案。"
  }];
  const stats = isZh ? statsZh : statsEn;
  return <section data-section-id="14824" id="production-capacity" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1360px] px-6 md:px-8">
        <div ref={intro.ref} className={`mx-auto max-w-[720px] text-center transition-all duration-700 ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-default uppercase text-[11px] md:text-xs tracking-[0.18em] text-foreground" style={{
          letterSpacing: "0.18em"
        }}>
            {isZh ? <>
                {"製造實力，"}
                <span className="font-serif italic normal-case tracking-normal text-primary">
                  規模化生產
                </span>
              </> : <>
                {"Manufacturing, "}
                <span className="font-serif italic normal-case tracking-normal text-primary">
                  scaled
                </span>
              </>}
          </p>

          <h2 className="font-default mt-6 font-sans font-bold text-foreground" style={{
          fontSize: "clamp(2rem, 4.4vw, 3.75rem)",
          lineHeight: 1.08,
          letterSpacing: "-0.018em"
        }}>
            {isZh ? <>
                {"以精準工藝 樹立"}
                <span className="italic">全球</span>
                {"標準"}
              </> : <>
                {"Precision that defines "}
                <span className="italic">global</span>
                {" standards"}
              </>}
          </h2>

          <p className="mt-6 font-default text-foreground" style={{
          fontSize: "clamp(1.0625rem, 1.35vw, 1.25rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.005em"
        }}>
            {isZh ? "我們的製造基礎設施專為高可靠性而建。從研發創新到最終品質檢測，我們為您的品牌提供在國際競爭市場中脫穎而出所需的核心技術支援。" : "Our manufacturing infrastructure is built for reliability. From R&D to final quality assurance, we provide the technical backbone your brand needs to succeed in competitive international markets."}
          </p>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 min-[480px]:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {stats.map((stat, i) => {
          const cell = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.2
          });
          return <div data-index={i} key={stat.index} ref={cell.ref} className={`relative pt-6 transition-all duration-500 ease-out ${cell.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <div className="absolute top-0 left-0 right-0 h-px bg-border" />

                <p className="font-mono text-xs text-foreground tracking-wide">
                  {stat.index}
                </p>

                <p className="font-default mt-4 font-sans font-bold text-foreground" style={{
              fontSize: "clamp(2.25rem, 6.4vw, 5.75rem)",
              lineHeight: 1,
              letterSpacing: "-0.022em"
            }}>
                  {stat.figure}
                </p>

                <p className="mt-3 font-default font-bold text-base text-foreground leading-snug">
                  {stat.label}
                </p>

                <p className="mt-2 font-default text-sm text-foreground leading-relaxed">
                  {stat.footnote}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}